module.exports = __webpack_public_path__ + "static-appopensalud/img/hacienda.a79c76a.png";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/hacienda.png
// module id = 1044
// module chunks = 120